import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['info']
  static values = {
    url: String,
    bookingId: Number,
    startDate: String,
    endDate: String,
    typeIds: Array,
    siteId: Number
  }

  connect() {
    // Check availability when cart item is displayed
    this.check()
  }

  check() {
    if (!this.startDateValue || !this.endDateValue || !this.typeIdsValue.length) {
      return
    }

    const params = new URLSearchParams({
      booking_id: this.bookingIdValue,
      start_date: this.startDateValue.split('T')[0],
      start_time: this.startDateValue.split('T')[1] || '09:00',
      end_date: this.endDateValue.split('T')[0],
      end_time: this.endDateValue.split('T')[1] || '17:00'
    })

    // Add type_ids as array
    this.typeIdsValue.forEach(id => params.append('type_ids[]', id))

    if (this.siteIdValue) {
      params.append('site_id', this.siteIdValue)
    }

    fetch(`${this.urlValue}?${params.toString()}`)
      .then(response => response.json())
      .then(data => {
        this.showInfo(data)
      })
      .catch(error => {
        console.error('Availability check failed:', error)
      })
  }

  showInfo(data) {
    if (!this.hasInfoTarget) return

    const availability = data['available']

    if (availability) {
      // Not available - show warning
      this.infoTarget.textContent = availability
      this.infoTarget.classList.remove('d-none')
    } else {
      // Available - hide info
      this.infoTarget.classList.add('d-none')
    }
  }
}

